import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import cookieClient from 'react-cookies';
import CryptoJS from 'crypto-js';

// Types

var SECRET_KEY = process.env.RAZZLE_COOKIE_SECRET_KEY || 'default-cookie-secret';
var isClient = __IS_CSR__;
var isEncryptedData = function isEncryptedData(data) {
  try {
    var parsed = typeof data === 'object' ? data : JSON.parse(data);
    return (parsed === null || parsed === void 0 ? void 0 : parsed.hasOwnProperty('encv1')) && (parsed === null || parsed === void 0 ? void 0 : parsed.data);
  } catch (_unused) {
    return false;
  }
};
export var parseServerCookies = function parseServerCookies(request) {
  var parsedCookies = {};
  try {
    var cookieHeader = request.headers.cookie;
    if (!cookieHeader) return parsedCookies;
    var cookies = cookieHeader.split(';');
    cookies.forEach(function (cookie) {
      var _cookie$trim$split = cookie.trim().split('='),
        _cookie$trim$split2 = _slicedToArray(_cookie$trim$split, 2),
        key = _cookie$trim$split2[0],
        value = _cookie$trim$split2[1];
      if (!key || !value) return;
      var decodedValue = decodeURIComponent(value);
      if (isEncryptedData(decodedValue)) {
        try {
          var parsed = typeof decodedValue === 'object' ? decodedValue : JSON.parse(decodedValue);
          var bytes = CryptoJS.AES.decrypt(parsed.data, SECRET_KEY);
          var decrypted = bytes.toString(CryptoJS.enc.Utf8);
          parsedCookies[key] = JSON.parse(decrypted);
        } catch (_unused2) {
          parsedCookies[key] = decodedValue;
        }
      } else {
        try {
          parsedCookies[key] = typeof decodedValue === 'object' ? decodedValue : JSON.parse(decodedValue);
        } catch (_unused3) {
          parsedCookies[key] = decodedValue;
        }
      }
    });
  } catch (error) {
    console.error('Error parsing server cookies:', error);
  }
  return parsedCookies;
};
var cookieFunctionCreator = function cookieFunctionCreator(operation) {
  return function (key, value, options) {
    if (!isClient) return operation === 'get' ? null : undefined;
    try {
      switch (operation) {
        case 'get':
          {
            var cookie = cookieClient.load(key);
            if (!cookie) return null;
            if (isEncryptedData(cookie)) {
              try {
                var parsed = typeof cookie === 'object' ? cookie : JSON.parse(cookie);
                var bytes = CryptoJS.AES.decrypt(parsed.data, SECRET_KEY);
                var decrypted = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(decrypted);
              } catch (error) {
                console.error('Cookie decryption error:', error);
                return null;
              }
            }
            return cookie;
          }
        case 'set':
          {
            if (value === undefined) return;
            var encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
            cookieClient.save(key, JSON.stringify({
              data: encrypted,
              encv1: true
            }), options);
            break;
          }
        case 'remove':
          {
            cookieClient.remove(key, options);
            break;
          }
      }
    } catch (error) {
      console.error("Cookie ".concat(operation, " error:"), error);
      return operation === 'get' ? null : undefined;
    }
  };
};
var useCookieClient = function useCookieClient() {
  return {
    setCookieClient: cookieFunctionCreator('set'),
    getCookieClient: cookieFunctionCreator('get'),
    removeCookieClient: cookieFunctionCreator('remove')
  };
};
export default useCookieClient;